<template>
    <div v-if="isShowSpecialPage">
        <router-view></router-view>
    </div>
    <div class="new-main-cointainer" v-loading="hasLoading" :class="{active: isMobileApp}" v-else>

      <template v-if="!hasLoading">
        <div class="user_img" v-if="false && isMobileApp && !drawer">
            <img v-if="user.avatarUrl" :src="user.avatarUrl" alt="" @click="drawer = true">
            <img v-if="!user.avatarUrl" :src="defaultImg" alt="" @click="drawer = true">
        </div>
        <div class="mobile-header" v-if="isMobileApp && false">
            <img v-if="!isShowBackIcon && user.avatarUrl" :src="user.avatarUrl" alt="" @click="drawer = true">
            <img v-if="!isShowBackIcon && !user.avatarUrl" :src="defaultImg" alt="" @click="drawer = true">
            <i v-if="isShowBackIcon" class="el-icon-arrow-left" @click="handleBack"></i>
            {{ $route.meta.title == '工作台' ? '' : $route.meta.title }}
        </div>

        <div v-if="false && !isMobileApp" class="main-new-sidebar">
            <!-- <div v-show="!isNotShowAppSidebarByPage && !isShowAppSidebar" @mouseenter="showHoverSidebar" @click="isShowAppSidebar = true" class="show-button">
                <i class="el-icon-d-arrow-right"></i>
            </div> -->
            <section class="sidebar-logo" @click="handleClickLogo">
                <img src="../assets/images/sidebar-logo.png" alt="">
            </section>
            <section class="sidebar-apps">
                <div @mouseenter="showHoverSidebar(item.key)" class="item"
                    :class="{active: item.key === currentNewMenu}"
                    v-for="(item, index) in newMenu" :key="index"
                    @click="handleClickNewMenu(item.key)"
                    >
                    <img v-if="item.key === 'project'" src="../assets/images/sidebar-yewu.png" alt="">
                    <img v-if="item.key === 'psi'" src="../assets/images/sidebar-psi.png" alt="">
                    <img v-if="item.key === 'mine'" src="../assets/images/sidebar-mine.png" alt="">
                    <img v-if="item.key === 'okr'" src="../assets/images/sidebar-mubiao.png" alt="">
                    <img v-if="item.key === 'datemanagement'" src="../assets/images/app-sidebar-icon.png" alt="">
                    <img v-if="item.key === 'digitalHuman'" src="../assets/images/sidebar-yewu.png" alt="">
                    <span>{{item.name}}</span>
                </div>
            </section>
            <section class="sidebar-tools"></section>
            <section class="sidebar-user">
                <el-popover
                    popper-class="user-popover"
                    placement="right-end"
                    width="200"
                    v-model="popoverVisible"
                    trigger="click"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('accountSetting')">
                        <Icon type="ios-contact" style="margin-right: 5px;"/>
                        设置
                    </div>
                    <div v-permission = "'/bpm/company'" class="drop-menu-item" @click="handleClickUserMenuItem('memberMange')">
                        <Icon type="ios-people" style="margin-right: 5px;"/>
                        公司成员情况
                    </div>
                    <div v-permission = "'/bpm/company'" class="drop-menu-item" @click="handleClickUserMenuItem('settingManage')">
                        <Icon type="settings" style="margin-right: 5px;"/>
                        管理后台
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('invite')">
                        <Icon type="person-add" style="margin-right: 5px;"/>
                        邀请成员
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('loginout')">
                        <Icon type="log-out" style="margin-right: 5px;"/>
                        退出登录
                    </div>
                    <div slot="reference" class="user-head">
                        <img v-if="user.avatarUrl" :src="user.avatarUrl" alt="">
                        <img v-else :src="defaultImg" alt="">
                    </div>
                </el-popover>
            </section>
            <div class="hover-app-sidebar-mask" @mouseleave="hideHoverSidebar" v-show="isShowHoverSidebar">
                <div class="hover-app-sidebar">
                    <!-- <div class="app-title">{{ currentMenu.subTitle }}</div> -->
                    <div class="item" :class="{active: currentPageName === item.name}"
                        v-for="(item, index) in newHoverSidebar" :key="index" @click="changeMenu(index)">
                        <img src="../assets/images/app-sidebar-icon.png" alt="">
                        {{ item.name }}
                    </div>
                </div>
            </div>

        </div>
        <div class="main-new-container"  :class="{'mobile-main-new-cointainer': isMobileApp}" @mouseenter="hideHoverSidebar">
            <!-- <div v-show="!isNotShowAppSidebarByPage && isShowAppSidebar" class="app-sidebar">
                <div class="app-title">{{ currentMenu.subTitle }}</div>
                <div class="item" :class="{active: currentPageName === item.name}" v-for="(item, index) in currentMenu.children" :key="index" @click="changeMenu(index)">
                    <img src="../assets/images/app-sidebar-icon.png" alt="">
                    {{ item.title }}
                </div>
                <div class="hidden-button" @click="isShowAppSidebar = false">
                    <i class="el-icon-d-arrow-left"></i>
                </div>
            </div> -->
            <!-- <div v-if="currentNewMenu === 'project' || currentNewMenu === 'mine'" class="app-container">
                <businessProcessVue :isShowHeader.sync="isShowHeader" @clickMenu="clickMenu"></businessProcessVue>
            </div> -->
            <div class="app-container" v-loading="hasLoading">
                <template v-if="!hasLoading">
                <template v-if="$route.path.indexOf('workbench') > -1">
                    <keep-alive>
                        <router-view :isMobileApp.sync="isMobileApp"  :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
                    </keep-alive>
                    <router-view :isMobileApp.sync="isMobileApp" v-if="!$route.meta.keepAlive"></router-view>
                </template>

                <template v-else-if="$route.path == '/my/index'">
                    <template v-if="$route.meta.keepAlive">
                        <keep-alive >
                            <router-view :isMobileApp.sync="isMobileApp" v-if="$route.query" :key="$route.fullPath"></router-view>
                            <router-view :isMobileApp.sync="isMobileApp"></router-view>
                        </keep-alive>
                    </template>
                    <router-view :isMobileApp.sync="isMobileApp" v-else></router-view>
                </template>

                <template v-else>
                    <keep-alive :include="cachePage">
                        <router-view :isMobileApp.sync="isMobileApp" v-if="$route.query.projectId" :key="$route.path + $route.query.projectId"></router-view>
                        <router-view :isMobileApp.sync="isMobileApp" v-else></router-view>
                    </keep-alive>
                </template>
            </template>
            </div>
        </div>

        <invite :isMobileApp.sync="isMobileApp" :visible.sync="isShowInvite"></invite>
        <!-- <div class="mobile-footer" v-if="isMobileApp && !isShowBackIcon"> -->
        <div class="mobile-footer" v-if="false && isMobileApp">
            <div class="mobile-footer-item" :class="{active: item.key === $route.path || $route.path.indexOf(item.key) > -1 }" v-for="(item, index) in footerList" :key="index" @click="handleFooterClick(item)">
                <img v-if="item.key === $route.path && item.key === '/my/index'" src="../assets/images/okr/mobile-footer-project-blue.png" alt="">
                <img v-if="item.key !== $route.path && item.key === '/my/index'" src="../assets/images/okr/mobile-footer-project-grey.png" alt="">
                <img v-if="$route.path.indexOf(item.key) > -1 && item.key === '/workbench/list'" src="../assets/images/okr/mobile-footer-workbrench-blue.png" alt="">
                <img v-if="$route.path.indexOf(item.key) <= -1 && item.key === '/workbench/list'" src="../assets/images/okr/mobile-footer-workbrench-grey.png" alt="">
                {{ item.name }}
            </div>
        </div>
        <el-drawer
            v-if="isMobileApp"
            title="我是标题"
            ref="drawer"
            :visible.sync="drawer"
            size="285px"
            :with-header="false"
            :direction="'rtl'">
            <div class="mobile-sidebar-drawer">
                <div class="user-info">
                    <img v-if="user.avatarUrl" :src="user.avatarUrl" alt="">
                    <img v-else :src="defaultImg" alt="">
                    <div class="user-name">
                        {{ user.name }}
                    </div>
                </div>
                <div class="actions">
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('accountSetting')">
                        <Icon type="ios-contact" style="margin-right: 5px;"/>
                        设置
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('memberMange')">
                        <Icon type="ios-people" style="margin-right: 5px;"/>
                        公司成员情况
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('settingManage')">
                        <Icon type="settings" style="margin-right: 5px;"/>
                        管理后台
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('invite')">
                        <Icon type="person-add" style="margin-right: 5px;"/>
                        邀请成员
                    </div>
                    <div class="drop-menu-item" @click="handleClickUserMenuItem('loginout')">
                        <Icon type="log-out" style="margin-right: 5px;"/>
                        退出登录
                    </div>
                </div>
            </div>
        </el-drawer>
      </template>
    </div>

    <!-- <div v-else class="main" :class="{'main-hide-text': hideMenuText}">
        <div class="main-header">
            <div class="head-title">找找茶管理后台</div>
            <div class="head-tabs">
                <el-tabs v-model="activeMenu" @tab-click="handleClickMenu">
                    <template v-for="(item,index) in menuList" v-if="item.show">
                        <el-tab-pane :name="index+''" :key="index">
                            <span slot="label">
                                <el-dropdown @command="handleCommand">
                                    <span class="el-dropdown-link">
                                        {{item.title}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(secondItem,secondIndex) in item.children" :key="secondIndex" :command="beforeHandleCommand(index,secondIndex)">{{secondItem.title}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </el-tab-pane>
                    </template>
                </el-tabs>
            </div>
            <div class="header-avator-con hide-mobile">
                <div v-if="false">
                    <el-select
                    v-model="permissionName"
                    filterable
                    remote
                    clear
                    reserve-keyword
                    placeholder="请输入模块名"
                    @change="changePermission"
                    :remote-method="getlistPermissionSearchVO"
                    >
                    <el-option
                        v-for="item in options"
                        :key="item.permission"
                        :label="item.parentPermissionName"
                        :value="item.permission"
                    >
                    </el-option>
                    </el-select>
                </div>
                <div @click="handleFullScreen" v-if="showFullScreenBtn" class="full-screen-btn-con">
                    <Tooltip :content="isFullScreen ? '退出全屏' : '全屏'" placement="bottom">
                        <Icon :type="isFullScreen ? 'arrow-shrink' : 'arrow-expand'" :size="23"></Icon>
                    </Tooltip>
                </div>
                <div class="user-dropdown-menu-con">
                    <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
                        <Dropdown trigger="click" @on-click="handleClickUserDropdown">
                            <a href="javascript:void(0)">
                                <span class="main-user-name">{{ user.username }}</span>
                                <Icon type="arrow-down-b"></Icon>
                            </a>
                            <DropdownMenu slot="list" style="margin:-8px -4px -6px -4px">
                                <DropdownItem name="accountManageAccountSetting">
                                    <div class="drop-menu-item">
                                        <Icon type="ios-contact" style="margin-right: 5px;"/>
                                        设置
                                    </div>
                                </DropdownItem>
                                <DropdownItem name="accountManageMemberMange">
                                    <div class="drop-menu-item">
                                        <Icon type="ios-people" style="margin-right: 5px;"/>
                                        公司成员情况
                                    </div>
                                </DropdownItem>
                                <DropdownItem name="accountManageSettingMange">
                                    <div class="drop-menu-item">
                                        <Icon type="settings" style="margin-right: 5px;"/>
                                        管理后台
                                    </div>
                                </DropdownItem>
                                <DropdownItem name="invite">
                                    <div class="drop-menu-item">
                                        <Icon type="person-add" style="margin-right: 5px;"/>
                                        邀请成员
                                    </div>
                                </DropdownItem>
                                <DropdownItem name="loginout">
                                    <div class="drop-menu-item">
                                        <Icon type="log-out" style="margin-right: 5px;"/>
                                        退出登录
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </Row>
                </div>
            </div>
        </div>
        <div style="width:100%;padding:16px 120px 20px 140px;background: #f0f2f5">
            <div class="flexRow">
                <div :style="{width:hideMenuText?'0':'200px'}" class="sidebar-menu-con">
                    <sidebar-menu :menuList="menuList" :iconSize="20" v-show="showMenu"/>
                </div>
                <div class="main-content">
                    <div id="single-page-con" class="single-page-con">
                        <div class="single-page">
                            <keep-alive :include="cachePage">
                                <router-view></router-view>
                            </keep-alive>
                        </div>
                    </div>
                    <up-down srcollEl="#single-page-con"></up-down>
                </div>
            </div>
        </div>
        <invite :visible.sync="isShowInvite"></invite>
    </div> -->
</template>
<script>
// import upDown from '@/common/upDown.vue'
import util from '@/libs/util.js'
import Admin from '@/tool/Admin.js'
// import sidebarMenu from './main_components/sidebarMenu2.vue'
// import tagsPageOpened from './main_components/tagsPageOpened.vue'
import invite from '@zzcbpmDashboard/zhaocha/accountManage/invite/inviteDialog'
// import businessProcessVue from './businessProcess.vue'

    export default {
        components: {
            // sidebarMenu,
            // tagsPageOpened,
            // upDown,
            invite,
            // businessProcessVue
        },
        data() {
            return {
                hasLoading: true,
                cachedViews: [
                    'workbench/list',
                    'workbench/list4',
                    'workbench/list5',
                    'my/index'
                ],
                popoverVisible: false,
                drawer: false,
                footerList: [
                    {name: '工作台', key: '/workbench/list'},
                    {name: '工作项', key: '/my/index'},
                ],
                isMobileApp: false,
                isShowHeader: true,
                // newMenu: [
                //     {name: '工作项', key: 'project'},
                //     {name: '进销存', key: 'psi'},
                // ],
                currentNewMenu: 'digitalHuman',
                newHoverSidebar: [
                    {name: '我的项目', key: 'project'},
                    {name: '任务管理', key: 'mission'},
                    {name: '需求管理', key: 'requirement'},
                    {name: '目标管理', key: 'okr'},
                ],
                isShowHoverSidebar: false,
                // isHoverSidebar: true,
                currentApp: {},
                defaultImg: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
                isShowAppSidebar: true,
                appSidebarList: [],
                isShowInvite: false,
                user: {},
                spanLeft: 4,
                spanRight: 20,
                hideMenuText: false,
                showFullScreenBtn: window.navigator.userAgent.indexOf('MSIE') < 0,
                messageCount: 0,
                lockScreenSize: 0,
                buttonPermissionList: [],
                showMenu: false,
                activeMenu: "0",
                options: [],
                permissionName: "",
                permissionRouterList: [],
            };
        },
    computed: {
        newMenu() {
            return this.$store.state.env == 'test' ? [
                    {name: '工作项', key: 'project'},
                    {name: '进销存', key: 'psi'},
                    {name: '总后台', key: 'datemanagement'},
                    {name: '数字人', key: 'digitalHuman'},
                ] : [
                    {name: '工作项', key: 'project'},
                    {name: '数字人', key: 'digitalHuman'},
                ]
        },
        isTest() {
            return this.$store.state.env == 'test'
        },
        isMine() {
            console.log('isMine',localStorage.getItem('projectTab') == 'my');
            return localStorage.getItem('projectTab') == 'my'
        },
        isShowBackIcon() {
            return this.$route.fullPath !== '/my/index' && this.$route.fullPath !== '/workbench/list'
        },
        currentRouteName() {
            console.log(this.$route)
            return this.$route.name
        },

        currentMenu() {
            return this.$store.state.currentMenu
        },

        currentPageName() {
            return this.$store.state.currentPageName
        },

        menuList() {
            return this.$store.state.menuList;
        },

        tagsList() {
            return this.$store.state.tagsList;  // 所有页面的页面对象
        },

        pageTagsList() {
            return this.$store.state.pageOpenedList;  // 打开的页面的页面对象
        },

        currentPath() {
            return this.$store.state.currentPath;  // 当前面包屑数组
        },

        menuIconColor() {
            return this.$store.state.menuTheme === 'dark' ? 'white' : '#495060';
        },

        cachePage() {
            console.log('cachePage',this.$store.state.cachePage);
            return this.$store.state.cachePage;
        },

        isNotShowAppSidebarByPage() {
            const specialPages = [
                'invite',
                'invite-register',
                'share-list'
            ]
            return specialPages.includes(this.$store.state.cachePage[0])
        },

        isShowSpecialPage() {
            let specialPages = [
                'invite',
                'invite-register',
            ]
            if (this.isMobileApp) {
                specialPages = specialPages.concat([
                    'daily-report',
                    'daily-report-submit'
                ])
            }
            return specialPages.includes(this.$store.state.cachePage[0])
        },

        isFullScreen() {
            return this.$store.state.isFullScreen;
        }
    },
    methods: {
        goReport() {
            this.$router.push({name: 'daily-report'})
        },
        handleBack() {
            this.$router.go(-1)
        },
        handleFooterClick(item) {
            this.$router.push({
                path: item.key
            })
        },
        clickMenu() {
            this.currentNewMenu = 'project'
            this.isShowHeader = true
            localStorage.setItem('isShowHeader', true)
            localStorage.setItem('currentMenu', 'project')
            this.$router.push({
                path: '/businessProcess/task/list'
            })
        },
        handleClickNewMenu(key) {
            // this.currentNewMenu = key
            // localStorage.setItem('currentMenu', key)
            console.log(this.currentNewMenu)
            let beforeUrl = ''
            if(this.isTest) {
                beforeUrl = '/zzcbpm/admin'
            }
            // this.isShowHeader = true
            // localStorage.setItem('isShowHeader', true)
            if (key === 'project') {
                // this.isShowHeader = false
                // localStorage.setItem('isShowHeader', 0)
                // this.$router.push({
                //     path: '/my/index'
                // })
                this.goToNewUrl(`${beforeUrl}/#/my/index`)
            }
            if (key === 'psi') {
                this.goToNewUrl("/digitalHuman/#/index")
            }
            // if (key === 'mine') {
            //     this.$router.push({
            //         path: '/my/index'
            //     })
            // }
            // if (key === 'okr') {
            //     this.$router.push({
            //         path: '/businessProcess/okr/list'
            //     })
            // }
          if (key === 'datemanagement') {
            if(this.isTest) {
                beforeUrl = '/zzcbpm/datemanagement'
            }
            this.goToNewUrl(`${beforeUrl}/#/datemanagement/share/list`)
          }
          if (key === 'digitalHuman') {
            this.$router.push({
                path: '/index'
            })
          }
        },
      goToNewUrl(url) {
        window.location.href = url;
      },
        showHoverSidebar(key) {
            if (key === 'mine') {
                // this.isShowHoverSidebar = true
            }
        },
        hideHoverSidebar() {
            this.isShowHoverSidebar = false
        },
        changeMenu(index) {
            console.log(
                "active",
                index,
                this.$route.name,
            );
            let menu = this.currentMenu.children[index]
            console.log('this.currentMenu.path',this.currentMenu.path,menu.path);
            this.$router.push({
                path:
                    this.currentMenu.path +
                    "/" +
                    menu.path,
            });
        },
        handleClickSidebarApp(item, index) {
            this.currentApp = item
            this.activeMenu = index
            this.handleClickMenu()
            this.$router.push({
                path:
                    this.menuList[index].path +
                    "/" +
                    this.menuList[index].children[0].path,
            });
        },
        handleClickLogo() {
            // this.isShowHeader = false
            // this.currentNewMenu = ''
            // localStorage.setItem('isShowHeader', 0)
            // this.$router.push('/workbench/list')
        },
            init() {
                // this.$store.commit('setCurrentPageName', this.$route.name);
                // let pathArr = util.setCurrentPath(this, this.$route.name);
                // if (pathArr.length >= 2) {
                //     this.$store.commit('addOpenSubmenu', pathArr[1].name);
                // }
            },
            changePermission(e) {
                console.log(this.$route.path);
                console.log(e, "e");

                this.permissionRouterList.forEach((item) => {
                    if (item.permission == e) {
                    console.log(item.path);
                    if (this.$route.path != "/datemanagement" + "/" + item.path) {
                        console.log(item.path);
                        this.$router.push({
                        path: "/" + item.path,
                        });
                    }
                    }
                });
            },
            async getlistPermissionSearchVO(permissionName) {
                // let res = await Classify.prototype.getlistPermissionSearchVO({
                //     permissionName,
                //     platformId: 1,
                // });

                // let router = [];
                // this["$router"].options.routes.forEach((item) => {
                //     if (item.path == "/datemanagement") {
                //     router.push(item);
                //     }
                // });
                // this.permissionRouterList = this.flatList(router);
                // console.log(this.permissionRouterList, "this.permissionRouterList");
                // this.options = res.data.data;
            },
            flatList(arr) {
                let arrNew = [];
                arr.forEach((item) => {
                    arrNew.push(item);
                    if (item.children) {
                    item.children.forEach((element) => {
                        arrNew.push(element);
                    });
                    }
                });
                return arrNew;
            },
            //点击头部菜单栏
            handleClickMenu(tab,event) {
                //this.activeMenu 选中值
                let currentMenu = this.menuList[this.activeMenu]
                this.$store.state.currentMenu = currentMenu
                console.log('currentMenu',currentMenu);
                localStorage.setItem('currentMenu',JSON.stringify(currentMenu))
                this.$router.push({
					path:
                        currentMenu.path +
                        "/" +
						currentMenu.children[0].path,
				});
            },
            beforeHandleCommand(index, command) { //index我这里是遍历的角标，即你需要传递的额外参数
                return {
                'index': index,
                'command': command
                }
            },
            //点击头部菜单栏的下拉菜单项
            handleCommand(data) {
                console.log('click on item ', data);
                this.activeMenu = data.index + ''
                this.handleClickMenu()
                this.$router.push({
					path:
						this.menuList[data.index].path +
                        "/" +
						this.menuList[data.index].children[data.command].path,
                });
            },
            toggleClick() {
                this.hideMenuText = !this.hideMenuText;
        },

        handleClickUserMenuItem(name) {
            let that = this;
            this.drawer = false
            this.popoverVisible = false
            let beforeUrl = ''
            if(this.isTest) {
                beforeUrl = '/zzcbpm/admin'
            }
            this.goToNewUrl(`${beforeUrl}/#/datemanagement/share/list`)
            if (name === 'loginout') {
                Admin.prototype.logout().then(() => {
                    that.$store.commit('clearOpenedSubmenu');
                    localStorage.removeItem('user');
                    localStorage.removeItem('currentUser');
                    this.$store.commit('updateMenulist');
                    that.$router.push('/login');
                });
            } else if (name === 'invite') {
                this.isShowInvite = true
            } else if (name === 'settingManage') {
                // this.$router.push({
                //     path: '/accountManage/settingManage/index'
                // })
                this.goToNewUrl(beforeUrl + '/#/accountManage/settingManage/index')
            } else if (name === 'accountSetting') {
                // this.$router.push({
                //     path: '/accountManage/accountSetting/index'
                // })
                this.goToNewUrl(beforeUrl + '/#/accountManage/accountSetting/index')
            } else if (name === 'memberMange') {
                // this.$router.push({
                //     path: '/accountManage/memberMange/index'
                // })
                this.goToNewUrl(beforeUrl + '/#/accountManage/memberMange/index')
            } else {
                    this.menuList.map((item, index) => {
                        if (item.name === name) {
                            this.activeMenu = index + ''
                            this.handleClickMenu()
                            this.$router.push({
                                path:
                                this.menuList[index].path +
                                "/" +
                                this.menuList[index].children[0].path,
                            })
                        }
                    })
                }
        },

            handleClickUserDropdown(name) {
                let that = this;
                if (name === 'loginout') {
                    Admin.prototype.logout().then(() => {
                        that.$store.commit('clearOpenedSubmenu');
                        localStorage.removeItem('user');
                        this.$store.commit('updateMenulist');
                        that.$router.push('/login');
                    });
                } else if (name === 'invite') {
                    this.isShowInvite = true
                } else {
                    this.menuList.map((item, index) => {
                        if (item.name === name) {
                            this.activeMenu = index + ''
                            this.handleClickMenu()
                            this.$router.push({
                                path:
                                this.menuList[index].path +
                                "/" +
                                this.menuList[index].children[0].path,
                            })
                        }
                    })
                }
            },

            handleFullScreen() {
                this.$store.commit('handleFullScreen');
            },

            checkTag(name) {
                let openpageHasTag = this.pageTagsList.some(item => {
                    if (item.name === name) {
                        return true;
                    }
                });
                if (!openpageHasTag) {  //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
                    util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {});
                }
            },

            //获取当前用户信息
            getCurrentUser() {
                let menuList = this.$store.state.menuList
                //设置当前菜单
                // let currentMenu = JSON.parse(localStorage.getItem('currentMenu'))
                // this.$store.state.currentMenu = currentMenu || menuList[0]
                // if(currentMenu) {
                //     menuList.forEach((item,index) => {
                //         if(item.title == currentMenu.title) {
                //             this.activeMenu = index + ''
                //         }
                //     })
                // }
                // this.$store.state.menuList = menuList
                this.showMenu = true
                const that = this;
                Admin.prototype.getCurrentInfo().then(
                    res => {
                        res = res || {}
                        res.data = res.data || {}
                        if(!res.data.data) {
                            localStorage.removeItem('user');
                            location.href = `#/login?returnUrl=${location.href}`;
                        } else {
                            res.data.data = {...res.data.data, ...res.data.extra}
                            let menuList = this.$store.state.menuList
                            that.user = res.data.data || {};
                            console.log('currentUser')
                            console.log(that.user)
                            localStorage.setItem('currentUser', JSON.stringify(that.user))
                            //获取菜单权限，展示对应菜单
                            let permissions = res.data.extra.listAllPermission
                            localStorage.setItem('digitalHuman_permission', JSON.stringify(permissions))
                            // let permissions = res.data.data.roles[0].permissions || []
                            // menuList = that.processList2(menuList,permissions)
                            // menuList = that.processList(menuList,res.data.extra.listAllPermission)
                            this.$store.state.menuList = menuList
                            //设置当前菜单
                            // let currentMenu = JSON.parse(localStorage.getItem('currentMenu'))
                            // this.$store.state.currentMenu = currentMenu || menuList[0]
                            // if(currentMenu) {
                            //     menuList.forEach((item,index) => {
                            //         if(item.title == currentMenu.title) {
                            //             this.activeMenu = index + ''
                            //         }
                            //     })
                            //     this.$store.state.menuList = menuList
                            // }
                            this.showMenu = true
                        }
                    },
                    () => {
                        console.log('===========');
                        localStorage.removeItem('user');
                        location.href = `#/login?returnUrl=${location.href}`;
                    }
                );
            },
            processList2(menuList,permissions) {
                let arr = []
                menuList.forEach(item => {
                    if(item.title == '欢迎页面') {
                        arr.push(item)
                    }
                    permissions.forEach(i =>{
                        if(item.title == i.permissionName) {
                            arr.push(item)
                        }
                    })
                })
                return arr
            },
            /***
             * 将 扁平化数组 转化成 层级数组
             * @param data 数组
             * @param id  唯一值的key值
             * @param pid 父id的key值
             * @returns {[]}
             */
            treeDataTranslate(data, id = 'id', pid = 'parentId') {
                let res = []
                let temp = {}
                for (let i = 0; i < data.length; i++) {
                    temp[data[i][id]] = data[i]
                }
                for (let k = 0; k < data.length; k++) {
                    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
                        if (!temp[data[k][pid]]['children']) {
                            temp[data[k][pid]]['children'] = []
                        }
                        if (!temp[data[k][pid]]['_level']) {
                            temp[data[k][pid]]['_level'] = 1
                        }
                        data[k]['_level'] = temp[data[k][pid]]._level + 1
                        temp[data[k][pid]]['children'].push(data[k])
                    } else {
                        res.push(data[k])
                    }
                }
                return res
            },

            //整理列表
            processList(list,permissionList) {

                let navList = this.treeDataTranslate(permissionList)
                // this.getButtonPermission(navList)
              this.getBpmPermission(navList)
                // this.navList = navList
                // console.log(navList)

                // console.log('权限')
                let arr = []
                // console.log(list)
                // console.log(permissionList)
                list.forEach(first => {
                    permissionList.forEach(second => {
                        if (first.permission
                            && second.permission
                            && first.permission === second.permission) {
                            arr.push({
                                ...first
                            })
                        }
                    })
                })
                // console.log(arr)
                arr.forEach(first => {
                    let childArr = []
                    if (first.children) {
                        first.children.forEach(child => {
                            for(let i= 0; i < permissionList.length; i++) {
                                if (permissionList[i].type === 3) {

                                    if (child.permission === (permissionList[i].permission +  '|' + permissionList[i].requestMethod)) {
                                        childArr.push({
                                            ...child
                                        })
                                        continue;

                                    }
                                }
                            }
                        })
                    }
                    // console.log(childArr)
                    if (childArr.length > 0) {
                        first.children = childArr
                    }else  {
                        first.children = []
                    }
                })
                console.log(arr)
                return arr
            },
            getBpmPermission(list) {
              let arr = list.filter(item => {
                    if(item.includes("/bpm")){
                      return true
                    }
              })

              // console.log('获取bpm权限列表', arr)
              localStorage.setItem('bpm_permission', JSON.stringify(arr))
            },
            getButtonPermission(list) {
                // console.log('获取权限列表', list)
                let arr = list.filter(item => {
                    return item.permission === "/bpm"
                })
                this.dealList(arr)

                localStorage.setItem('bpm_button_permission', JSON.stringify(this.buttonPermissionList))
            },
           dealList(list) {
                list.forEach(first => {
                    if (!first.children) {
                        if (first.type === 4) {
                            this.buttonPermissionList.push(first.permission + '|' + first.requestMethod)
                        }
                    }else {
                        this.dealList(first.children)
                    }
                })
            },
            dealMenuList(arr) {
                let menuList = this.$store.state.menuList;
                console.log(menuList);
                menuList.forEach(item => {
                    if (item.children.length > 0 ) {
                        item.children.forEach(s => {
                            s.show = false
                        })
                    }else {
                        item.show = false
                    }
                });
                console.log(arr);
                arr.forEach(item => {
                    menuList.forEach((item1,index) => {
                        if (item1.children.length > 0) {
                            item1.show = true
                            item1.children.forEach(s => {
                                let name = s.path.split('/')[0];
                                if (item.permission === name) {
                                    s.show = true;
                                }
                            })

                        }else {
                            item1.show = true
                        }
                    })
                });
                menuList.forEach(item => {
                    let num = 0;
                    item.children.forEach(item1 => {
                        if (item1.show) {
                            num ++;
                        }

                    });
                    if (num === 0) {
                        item.show = false
                    }
                })
                this.menuList = menuList;

                console.log(menuList)
            }
        },

        watch: {
            // '$route'(to) {
            //     console.log(to)
            //     this.$store.commit('setCurrentPageName', to.name);
            //     let pathArr = util.setCurrentPath(this, to.name);
            //     if (pathArr.length > 2) {
            //         this.$store.commit('addOpenSubmenu', pathArr[1].name);
            //     }
            //     this.checkTag(to.name);

            //     localStorage.currentPageName = to.name;
			// 	this.$store.state.currentPageName = to.name
            // }
        },
        mounted() {

        },

    async created() {
        const crmCode = this.$route.query.crmCode; // 获取 code 参数的值
        if (crmCode) {
          let res = await Admin.prototype.loginBySupportSid({code: crmCode})
          if(res && res.data.data) {
            localStorage.setItem('token', res.data.data.sid)
          }
        }
        // let startX = 0
        // let startY = 0
        // document.addEventListener('touchstart', (e) => {
        //     e.preventDefault()
        //     startX = e.changedTouches[0].pageX
        //     startY = e.changedTouches[0].pageY
        // })
        // document.addEventListener('touchmove', (e) => {
        //     let endX = e.changedTouches[0].pageX
        //     let endY = e.changedTouches[0].pageY
        //     let x = endX - startX
        //     let y = endY - startY
        //     if (Math.abs(x) > Math.abs(y) && x < 0 && (document.body.clientWidth - startX) < 50) {
        //         e.preventDefault()
        //         this.drawer = true
        //     } else if (Math.abs(x) > Math.abs(y) && x > 0) {
        //         e.preventDefault()
        //         this.drawer = false
        //     }
        // })
            const userAgent = navigator.userAgent
            this.isMobileApp = /Android|iPhone/.test(userAgent)
            this.isShowHeader = localStorage.getItem('isShowHeader') == 0 ? false : true
            // this.currentNewMenu = localStorage.getItem('currentMenu')
            console.log(this.$route)
            this.hasLoading = false
            this.init();
            if (!this.isShowSpecialPage) {
                // this.getCurrentUser();
                let menuList = this.$store.state.menuList
                this.showMenu = true
                const that = this;
                Admin.prototype.getCurrentInfo().then(
                    res => {
                        this.hasLoading = false
                        res = res || {}
                        res.data = res.data || {}
                        if(!res.data.data) {
                            localStorage.removeItem('user');
                            location.href = `#/login?returnUrl=${location.href}`;
                        } else {
                            res.data.data = {...res.data.data, ...res.data.extra}
                            let menuList = this.$store.state.menuList
                            that.user = res.data.data || {};
                            console.log('currentUser')
                            console.log(that.user)
                            localStorage.setItem('currentUser', JSON.stringify(that.user))
                          //获取菜单权限，展示对应菜单
                          let permissions = res.data.extra.listAllPermission || []
                            localStorage.setItem('digitalHuman_permission', JSON.stringify(permissions))
                        //   let permissions = res.data.data.permissions || []
                        //   menuList = that.processList(menuList,permissions)
                            // this.$store.state.menuList = menuList
                            this.showMenu = true
                            this.$store.commit('changeMenuTheme', 'dark');
                            this.$store.commit('changeMainTheme', 'b');
                            this.$store.commit('setOpenedList');
                        }
                    },
                    () => {
                        this.hasLoading = false
                        console.log('===========');
                        localStorage.removeItem('user');
                        location.href = `#/login?returnUrl=${location.href}`;
                    }
                );
                // this.user = JSON.parse(localStorage.getItem('user')) || {};
                // this.hideMenuText = document.documentElement.clientWidth <= 768;
            }
    },
        beforeRouteUpdate(to, from, next) {
            // console.log('beforeRouteUpdate')
            // console.log(this.$route)
            // localStorage.setItem('projectTab', 'mission')
            // this.currentTab = 'mission'
            // this.$refs.header.setActiveTab(this.currentTab)
            next()
        },
        beforeRouteLeave(to, from, next) {
            // console.log('beforeRouteLeave')
            // localStorage.setItem('projectTab', 'mission')
            next()
        }
    };
</script>

<style lang="less" scoped>

    .cal-mission-pop {
        width: 300px!important;
    }
    .project-board-popper {
        padding: 0;
    }

    .drop-menu-item {
        cursor: pointer;
        padding: 8px 16px;
        &:hover {
            background-color: #f7f7f7;
        }
    }

    /deep/ .user-popover {
        padding: 0!important;
    }

    .new-main-cointainer {
        width: 100vw;
        height: 100vh;
        position: relative;
        &.active {
            display: flex;
            flex-direction: column;
        }

        .mobile-header {
            width: 100%;
            height: 44px;
            min-height: 44px;
            max-height: 44px;
            position: relative;
            // top: 0;
            // left: 0;
            // right: 0;
            // padding-left: 50px;
            line-height: 44px;
            text-align: center;
            font-size: 17px;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 400;
            color: black;
            border-bottom: 1px solid #f2f2f2;
            z-index: 2;
            img {
                margin: auto;
                position: absolute;
                left: 16px;
                top: 0;
                bottom: 0;
                width: 32px;
                height: 32px;
                border-radius: 50%;
                z-index: 3;
            }
            .el-icon-arrow-left {
                margin: auto;
                position: absolute;
                left: 16px;
                display: block;
                top: 0;
                bottom: 0;
                height: 32px;
                line-height: 32px;
            }
        }

        .main-new-sidebar {
            z-index: 9;
            box-shadow: 0px 3px 10px 1px rgba(0,0,0,0.05);
            width: 80px;
            left: 0;
            top: 0;
            bottom: 0;
            position: absolute;
            display: flex;
            flex-direction: column;
            .show-button {
                cursor: pointer;
                position: absolute;
                z-index: 1000;
                top: 20px;
                right: -40px;
                width: 33px;
                height: 33px;
                border-radius: 50%;
                border: 1px solid rgba(0,0,0,0.1);
                background: white;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover {
                    background: #1b9aee;
                    color: white;
                }
            }
            section {
                width: 100%;
            }
            .sidebar-logo {
                height: 73px;
                padding: 21px 6px 0 6px;
                img {
                    cursor: pointer;
                    width: 68px;
                    height: auto;
                }
            }

            .sidebar-apps {
                flex: 1;
                padding: 0 10px;
                .item {
                    margin-bottom: 10px;
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    width: 60px;
                    height: 55px;
                    border-radius: 10px 10px 10px 10px;
                    text-align: center;
                    font-size: 14px;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    color: #666666;
                    img {
                        width: 22px;
                        height: 22px;
                    }
                    &.active {
                        background: #F6F7F9;
                    }
                    &:hover {
                        background: #F6F7F9;
                    }
                }
            }
            .sidebar-user {
                height: 80px;
                display: flex;
                justify-content: center;
                align-items: center;
                .user-head {
                    cursor: pointer;
                    width: 36px;
                    height: 36px;
                    border-radius: 100%;
                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 100%;
                    }
                    &:hover {
                        box-shadow: 0 0 10px rgba(0,0,0,0.5);
                    }
                }
            }
            .hover-app-sidebar-mask {
                position: absolute;
                width: 253px;
                // padding: 20px 24px;
                left: 80px;
                top: 0;
                bottom: 0;
                z-index: 999;
                // padding: 20px 24px;
                .hover-app-sidebar {
                    position: absolute;
                    width: 253px;
                    padding: 20px 24px;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    height: 80%;
                    background: white;
                    margin: auto;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                    padding: 20px 24px;
                    .app-title {
                        font-size: 18px;
                        font-family: Source Han Sans SC, Source Han Sans SC;
                        font-weight: bold;
                        color: #333333;
                        line-height: 33px;
                        margin-bottom: 27px;
                    }
                    .item {
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        width: 205px;
                        height: 40px;
                        border-radius: 8px 8px 8px 8px;
                        &.active {
                            background: #E0F1FF;
                        }
                        &:hover {
                            background: #F6F7F9;
                        }
                        img {
                            margin-left: 10px;
                            margin-right: 5px;
                            width: 25px;
                            height: 25px;
                        }
                    }
                }
            }
        }
        .main-new-container {
            // padding-left: 80px;
            display: flex;
            width: 100%;
            height: 100%;
            .app-sidebar {
                position: relative;
                border-right: 1px solid rgba(10,137,255,0.2);
                width: 253px;
                padding: 20px 24px;
                .hidden-button {
                    cursor: pointer;
                    position: absolute;
                    top: 20px;
                    right: -16px;
                    width: 33px;
                    height: 33px;
                    border-radius: 50%;
                    border: 1px solid rgba(0,0,0,0.1);
                    background: white;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &:hover {
                        background: #1b9aee;
                        color: white;
                    }
                }
                .app-title {
                    font-size: 18px;
                    font-family: Source Han Sans SC, Source Han Sans SC;
                    font-weight: bold;
                    color: #333333;
                    line-height: 33px;
                    margin-bottom: 27px;
                }
                .item {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    width: 205px;
                    height: 40px;
                    border-radius: 8px 8px 8px 8px;
                    &.active {
                        background: #E0F1FF;
                    }
                    &:hover {
                        background: #F6F7F9;
                    }
                    img {
                        margin-left: 10px;
                        margin-right: 5px;
                        width: 25px;
                        height: 25px;
                    }
                }
            }
            .app-container {
                flex: 1;
                // padding-left: 35px;
                overflow: hidden;
                background: #f7f7f7;
                display: flex;
                flex-direction: column;
            }
        }
        .mobile-main-new-cointainer {
            flex: 1;
            padding-left: 0;
            // padding-top: 50px;
            overflow-y: hidden;
            // padding-bottom: 50px;
        }
        .mobile-footer {
            box-shadow: 0px -1px 6px 0px rgba(0,0,0,0.03);
            // position: fixed;
            background: white;
            // bottom: 0;
            // left: 0;
            // right: 0;
            display: flex;
            height: 49px;
            max-height: 49px;
            min-height: 49px;
            .mobile-footer-item {
                width: 50%;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                font-family: Source Han Sans, Source Han Sans;
                font-weight: 400;
                color: #999999;
                img {
                    width: 24px;
                    height: 24px;
                    // margin-bottom: 6px;
                }
                &.active {
                    color: #1C98EE;
                }
            }
        }
        /deep/ .mobile-sidebar-drawer {
            width: 285px;
            padding-left: 20px;
            padding-top: 20px;
            .user-info {
                img {
                    width: 54px;
                    height: 54px;
                    border-radius: 50%;
                }
                .user-name {
                    font-size: 18px;
                    font-family: Source Han Sans, Source Han Sans;
                    font-weight: 400;
                    color: black;
                }
            }
            .actions {
                margin-top: 30px;
                .drop-menu-item {
                    cursor: pointer;
                    padding: 12px 16px 12px 0;
                    &:hover {
                        background-color: #f7f7f7;
                    }
                }
            }
        }
    }
    .user_img {
        position: fixed;
        right:16px;
        bottom: 140px;
        width: 3.375rem;
        height: 3.375rem;
        z-index: 9999;
        img {
                // width: 32px;
                // height: 32px;
                width: 3.375rem;
                height: 3.375rem;
                border-radius: 50%;

            }
    }
    .daily-report {
        position: fixed;
        right: 16px;
        bottom: 200px;
        width: 3.375rem;
        height: 3.375rem;
        line-height: 3.375rem;
        text-align: center;
        z-index: 9999;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        background: #3B92FF;
        border-radius: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/digitalHuman/views/Main.vue